import React, { Suspense } from 'react';
import Cookies from 'js-cookie';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import ErrorBoundary from 'Component/ErrorBoundary';
import FirebaseProvider from '@context/firebase';

import Maintenance from '@screens/Maintenance';

import { DownloadPage } from '@screens/GeneralScreen';

import { COOKIE_KEY } from '@config/constanta';

import TrackerProvider from '@context/tracker';
import routes from './routes';

function Router() {
  const validToken = Cookies.get('pin_token');
  const auth = typeof validToken !== 'undefined' && validToken !== null;

  if (!auth) {
    Cookies.set(COOKIE_KEY.redirect, window.location.pathname);
  }

  if (isMobile) {
    return <DownloadPage />;
  }

  const router = createBrowserRouter(routes);

  return (
    <Suspense fallback={null}>
      <ErrorBoundary render={() => <Maintenance />}>
        <TrackerProvider>
          <FirebaseProvider>
            <RouterProvider router={router} />
          </FirebaseProvider>
        </TrackerProvider>
      </ErrorBoundary>
    </Suspense>
  );
}

export default Router;
